<div>
    <mat-dialog-content>
        <div class="header">
            <div class="title {{cssClass}}" *ngIf="title != 'Information'">
                @if (cssClass == 'success-snackbar') {
                    <img src="/assets/icons/Badgegreen-check.svg"  alt="Badgegreen-check" />
                } @else {
                    <img src="/assets/icons/red-Badge.svg" alt="red-Badge"  />
                }
                
                

                {{title}}
            </div>
            <div class="title-info"  *ngIf="title == 'Information'">
                <img src="/assets/icons/Info_Icon_2.svg" alt="Info_Icon_2"   />
                
              
                {{title}}
            </div>

            <div>
                <img src="/assets/icons/Close-new.svg" alt="Close-new" (click)="onConfirmClick()" />
            </div>
        </div>
        <div *ngIf="cssClass != 'show-full-message'" class="message prompt-card-title" title="{{message}}" [innerHTML]="message"></div>
        <div *ngIf="cssClass == 'show-full-message'" class="message" style="max-height: 55px; overflow: auto;" [innerHTML]="message"></div>
    </mat-dialog-content>
</div>

